import React from 'react';
import { IShopNavigationMenuItem } from '../../model';
import CategoryList from '../CategoryList/CategoryList';
import styles from './Outdoor.module.scss';

interface IOutdoorProps {
  navItem: IShopNavigationMenuItem;
}

const Outdoor = ({
  navItem,
}: IOutdoorProps) => {
  const [outdoorFurniture, outdoorAccessories] = navItem.categoryChildren!;
  return (
    <div className={styles.FirstColumn}>
      <CategoryList
        menuItem={outdoorFurniture}
        canonicalParentSlug={navItem.slug}
      />
      <CategoryList
        menuItem={outdoorAccessories}
        canonicalParentSlug={navItem.slug}
      />
    </div>
  );
};

export default Outdoor;
